import type { IIncomeBusiness } from './IncomeBusiness.interface';
import IncomeBusinessTaxYear from './IncomeBusinessTaxYear';

export default class IncomeBusiness implements IIncomeBusiness {
  lastTaxYear: IncomeBusinessTaxYear;
  previousTaxYear: IncomeBusinessTaxYear;

  static build = (data: IIncomeBusiness) => new IncomeBusiness(data);
  static blank = () => new IncomeBusiness();

  /**
   * Constructor
   * @param {IIncomeBusiness} data
   */
  constructor(data?: IIncomeBusiness) {
    this.lastTaxYear = new IncomeBusinessTaxYear(data?.lastTaxYear);
    this.previousTaxYear = new IncomeBusinessTaxYear(data?.previousTaxYear);
  }
}
